import {useState} from "react";

import {METRICS} from "../../../utils/constants";

export const useMeasurementManagementState = () => {
  const [selectedGuestId, setSelectedGuestId] = useState<string>("");
  const [selectedGuestName, setSelectedGuestName] = useState<string>("");
  const [selectedMetric, setSelectedMetric] = useState<string>(METRICS[0].key);
  const [search, setSearch] = useState<string>("");

  const onPressMetric = (metricKey: string) => {
    setSelectedMetric(metricKey);
  };

  const onSelectGuest = (lineUserId: string, name: string) => {
    setSelectedGuestId(lineUserId);
    setSelectedGuestName(name);
  };

  return {
    selectedGuestId,
    selectedGuestName,
    selectedMetric,
    search,
    setSearch,
    onPressMetric,
    onSelectGuest,
  };
};
